@if (canEdit && serviceHosts && serviceHosts.length > 0) {
    <button type="button"
            class="ace-btn btn-sm btn-primary"
            (click)="sendMessage()"
            helpTooltip
            helpContentId="long-running-process-control.message"
            position="bottom">
        <i class="fa fa-exchange"></i> Control Message
    </button>
}
